import { apiRequest } from '@/utils/api-request';

interface ExportStartResponse {
  success: boolean;
  job_id: string;
  message: string;
}

interface ExportStatusResponse {
  success: boolean;
  job_id: string;
  status: 'running' | 'completed' | 'failed';
  workflow_count?: number;
  download_url?: string | null;
  error?: string;
  message?: string;
  errors?: string[];
}

export const startWorkflowExport = async (
  orgId: string,
): Promise<ExportStartResponse> => {
  const response = await apiRequest<ExportStartResponse>({
    url: `/workflow/${orgId}/export-all`,
    method: 'POST',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Unexpected empty response');
  }

  return response.data as ExportStartResponse;
};

export const getWorkflowExportStatus = async (
  orgId: string,
  jobId: string,
): Promise<ExportStatusResponse> => {
  const response = await apiRequest<ExportStatusResponse>({
    url: `/workflow/${orgId}/export-all/${jobId}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Unexpected empty response');
  }

  return response.data as ExportStatusResponse;
};
